import { StudentSectionSettingTypeCodes } from 'const';
import { scienceWidgetVisibilityHooks } from 'hooks';
import {
  scienceContestsSelector,
  scienceOccupationsSelector,
  scienceProjectsSelector,
  scienceRewardsSelector,
} from 'selectors';
import { getDataLoadRequests } from 'utils';

import { SectionLoaderConfig } from './types';

export const getScienceLoaderConfig = (): SectionLoaderConfig => {
  return [
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.scienceReward,
      requests: getDataLoadRequests().scienceRewards,
      loadingSelector: scienceRewardsSelector,
      dataSelector: (state) => scienceRewardsSelector(state).content.length > 0,
      useWidgetVisibility: scienceWidgetVisibilityHooks.useRewards,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.scienceProject,
      requests: getDataLoadRequests().scienceProjects,
      loadingSelector: scienceProjectsSelector,
      dataSelector: (state) => scienceProjectsSelector(state).content.length > 0,
      useWidgetVisibility: scienceWidgetVisibilityHooks.useProjects,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.scienceEmployment,
      requests: getDataLoadRequests().scienceOccupations,
      loadingSelector: scienceOccupationsSelector,
      dataSelector: (state) => scienceOccupationsSelector(state).content.length > 0,
      useWidgetVisibility: scienceWidgetVisibilityHooks.useEmployments,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.scienceContest,
      requests: getDataLoadRequests().scienceContests,
      loadingSelector: scienceContestsSelector,
      dataSelector: (state) => scienceContestsSelector(state).content.length > 0,
      useWidgetVisibility: scienceWidgetVisibilityHooks.useContests,
    },
  ];
};
